<script>
export default {
  name: "AuthFooter"
}
</script>

<template>
  <footer class="footer">
    <div>
      <span>&copy; 2025 Harvest v1.0.0. </span>
      <span>Created by <a href="https://sprintell.org"> Sprintell </a></span>
    </div>
    <div>
      <nav class="nav">
        <a href="" class="nav-link">Licenses</a>
        <a href="" class="nav-link">Change Log</a>
        <a href="https://discordapp.com/invite/5777678" class="nav-link">Get Help</a>
      </nav>
    </div>
  </footer>
</template>

<style scoped>

</style>
